import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress, Grid, IconButton, Link, makeStyles, Paper, Tooltip } from "@material-ui/core";
import { CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";
import { Autorenew, Search } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { get, set } from "@totalsoft/change-tracking-react";
import { onTextBoxChange } from "utils/propertyChangeAdapters";
import { customClientFilters } from "constants/customClientFilters";
import clientPageStyle from "features/client/styles";
import { emptyString } from "constants/defaultValues";

const useStyles = makeStyles(clientPageStyle);

function ExtendedFilters({ loading, condition, filterLens, getFilterProperty, onReset, onSearch, onExtended }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleKeypress = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        onSearch();
      }
    },
    [onSearch]
  );

  return (
    <Paper className={classes.filterStyle} onKeyUp={handleKeypress}>
      <Grid container spacing={2}>
        <Grid item container spacing={2}>
          {condition?.paramValues
            ?.filter((x) => x.code !== customClientFilters.legalForm)
            ?.map((item) => {
              return (
                <Grid item xs={12} sm={3} key={item.id}>
                  <CustomTextField
                    fullWidth
                    label={item.translatedName}
                    value={(getFilterProperty(item.code, filterLens) |> get) || emptyString}
                    onChange={getFilterProperty(item.code, filterLens) |> set |> onTextBoxChange}
                  />
                </Grid>
              );
            })}
        </Grid>
        <Grid item container justifyContent="space-between" alignItems="center">
          <Link
            id="clientSearch_extendedSearch"
            underline="always"
            color="primary"
            onClick={onExtended}
            className={classes.cursorLink}
          >
            {t("Client.BasicSearch")}
          </Link>
          <Grid item>
            <IconButton color="default" onClick={onReset} style={{ marginRight: 10 }}>
              <Tooltip title={t("General.ResetFilter")}>
                <Autorenew fontSize="small" />
              </Tooltip>
            </IconButton>
            <Button
              id="clientSearch_SearchBtn"
              right="true"
              variant="contained"
              color="primary"
              onClick={onSearch}
              endIcon={loading ? <CircularProgress size={20} color={"inherit"} /> : <Search />}
            >
              {t("General.Search")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

ExtendedFilters.propTypes = {
  loading: PropTypes.bool.isRequired,
  condition: PropTypes.object.isRequired,
  filterLens: PropTypes.object.isRequired,
  getFilterProperty: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onExtended: PropTypes.func.isRequired,
};

export default ExtendedFilters;
